// @flow
import * as React from 'react';
import { Container, Grid } from 'semantic-ui-react';
import ReactHtmlParser from 'react-html-parser';
import InlineCallbackForm from '../InlineCallbackForm';
import type {
  GetStartedWithProductCTA as ContentType,
  SendContact
} from '../../types';

type Props = {
  row: ContentType,
  sendContact: SendContact
};

type State = {
  success: boolean,
  error: boolean,
  submitted: boolean
};

class GetStartedWithProductCTA extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      success: false,
      error: false,
      submitted: false
    };
  }

  onSubmit = async (values: Object) => {
    try {
      this.setState({
        submitted: true
      });
      const result = await this.props.sendContact(
        values,
        'Live Product Request Callback',
        'Product Request Callback',
        window.location.href
      );
      this.setState({
        success: result,
        error: !result
      });
    } catch (error) {
      this.setState({
        success: false,
        error: true
      });
    }
  };

  render() {
    const { row } = this.props;
    return (
      <div className="page-row get-started-with-product-cta">
        <Container>
          <Grid stackable centered verticalAlign="middle">
            <Grid.Column width={4} tablet={6} computer={4}>
              {row.image &&
                row.image.url && (
                  <img src={row.image.url} alt={row.image.alt} />
                )}
            </Grid.Column>
            <Grid.Column width={1} className="show-for-xl" />
            <Grid.Column tablet={12} computer={8} largeScreen={7}>
              <h2>Get Started with {ReactHtmlParser(row.productName)}</h2>
              {row.text && <div>{ReactHtmlParser(row.text)}</div>}
              <InlineCallbackForm
                onSubmit={this.onSubmit}
                success={this.state.success}
                error={this.state.error}
                submitted={this.state.submitted}
              />
            </Grid.Column>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default GetStartedWithProductCTA;
